import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authen: false,
    time:'',
    uid: '',
    key: '',
    ou:'',
    bu:'',
    team:'',
    uuid:'',
    api:'',
    readinessGroup:[],
    readinessProcess:{
      Document:0,
      Sample:0,
      FAB:0,
      Sew:0,
      Pack:0,
      FC:0,
      Pattern:0
    }
  },
  plugins: [createPersistedState()],
  mutations: {
    setAuthen(state, authen) {
      state.authen = authen;
    },
    setTtime (state, time) {
      state.time = time;
    },
    setKey(state, key) {
      state.key = key;
    },
    setUID(state, uid) {
      state.uid = uid;
    },
    setUUID (state, uuid) {
      state.uuid = uuid;
    },
    setAPI (state, api) {
      state.api = api;
    },
     setOU(state, ou) {
      state.ou = ou;
    },
    setBU(state, bu) {
      state.bu = bu;
    },
    setTeam(state, team) {
      state.team = team;
    },
    setTeam(state, readinessGrp) {
      state.readinessGroup = readinessGrp;
    },
    setProcess(state, readinessProcess) {
      state.readinessProcess = readinessProcess;
    }
  },
  actions: {
  },
  getters: {
    authen: state => state.authen,
    time: state => state.time,
    key: state => state.key,
    uid: state => state.uid,
    uuid: state => state.uuid,
    api:state => state.api,
    ou: state => state.ou,
    bu: state => state.bu,
    team: state => state.team,
    readinessGroup: state => state.readinessGroup,
    readinessProcess: state => state.readinessProcess
  },
  modules: {
  }
})
